import React from 'react';
import Icon from 'components/AppIcon';
import Button from 'components/ui/Button';

const CategoryDetailsModal = ({ isOpen, onClose, category, onEdit }) => {
  if (!isOpen || !category) return null;

  const getStatusBadge = (status) => {
    const statusConfig = {
      active: { color: 'bg-success text-success-foreground', label: 'Active', icon: 'CheckCircle' },
      inactive: { color: 'bg-muted text-muted-foreground', label: 'Inactive', icon: 'XCircle' },
    };
    
    const config = status? statusConfig?.active : statusConfig?.inactive;
    
    return (
      <span className={`inline-flex items-center px-3 py-1 rounded-full text-sm font-medium ${config?.color}`}>
        <Icon name={config?.icon} size={16} className="mr-1" />
        {config?.label}
      </span>
    );
  };



  const InfoRow = ({ icon, label, value, className = '' }) => (
    <div className={`flex items-start space-x-3 ${className}`}>
      <Icon name={icon} size={18} className="text-muted-foreground mt-0.5 flex-shrink-0" />
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-muted-foreground">{label}</div>
        <div className="text-foreground break-words">{value || 'Not provided'}</div>
      </div>
    </div>
  );


  return (
    <div className="fixed inset-0 z-1002 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="fixed inset-0 bg-black/50 transition-opacity" onClick={onClose}></div>
        
        <div className="relative bg-card border border-border rounded-lg shadow-lg w-full max-w-3xl max-h-[90vh] overflow-hidden">
          {/* Header */}
          <div className="flex items-center justify-between p-6 border-b border-border">
            <div className="flex items-center space-x-4">

              <div>
                <h2 className="text-xl font-semibold text-foreground">{category?.name}</h2>
                <div className="flex items-center space-x-3 mt-1">
                  {getStatusBadge(category?.active)}
                </div>
                {/* <p className="text-sm text-muted-foreground mt-1">{category?.description}</p> */}
              </div>
            </div>
            <div className="flex items-center space-x-2">
              <Button variant="outline" size="sm" onClick={() => onEdit(category)}>
                <Icon name="Edit" size={16} className="mr-2" />
                Edit
              </Button>
              <Button variant="ghost" size="icon" onClick={onClose}>
                <Icon name="X" size={20} />
              </Button>
            </div>
          </div>

          {/* Content */}
          <div className="overflow-y-auto max-h-[calc(90vh-140px)]">
            <div className="p-6 space-y-8">
   
              <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <InfoRow icon="Mail" label="Category Name" value={category?.name} />
                </div>
              </div>

              <div className="space-y-4">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <InfoRow icon="FileText" label="Description" value={category?.description} />
                </div>
              </div> 
            </div>
          </div>

          {/* Footer */}
          <div className="flex items-center justify-between p-6 border-t border-border bg-muted/30">
            <div className="text-sm text-muted-foreground">
              Last updated: {new Date(category.updated)?.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'short',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </div>
            <div className="flex items-center space-x-3">
              <Button variant="outline" onClick={onClose}>
                Close
              </Button>
              <Button onClick={() => onEdit(category)} iconName="Edit" iconPosition="left" iconSize={16}>
                Edit Category
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CategoryDetailsModal;